import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContentpopupComponent } from './contentpopup/contentpopup.component';

import { FormValidatorDirective } from './directives';
import { SharedService } from './shared.service';
import { SafePipe } from './safe.pipe';

@NgModule({
  imports: [CommonModule],
  exports: [ContentpopupComponent,FormValidatorDirective,SafePipe],
  declarations: [ContentpopupComponent,FormValidatorDirective, SafePipe],
  providers: [SharedService]
})
export class SharedModule {}
